import React from 'react';
import { List, Datagrid, TextField, FunctionField } from 'react-admin';

const EventList = (props) => {
    const renderEventType = (record) => {
        switch (String(record.eventType)) {
            case 'IDEA':
                return 'Защита идеи';
            case 'ZERO_VERSION':
                return 'Защита нулевой версии';
            case 'PRE_RELEASE':
                return 'Предзащита';
            case 'RELEASE':
                return 'Итоговая защита';
            default:
                return record.eventType;
        }
    };

    const renderDate = (value) => {
        if (!value) {
            return '-';
        }

        return new Date(value).toLocaleDateString('ru-RU');
    };

    return (
        <List {...props} exporter={false} perPage={5}>
            <Datagrid rowClick="edit">
                <TextField source="name" label="Название" />

                <FunctionField
                    source="eventType"
                    label="Тип события"
                    render={renderEventType}
                />

                <TextField source="year" label="Год" />
                <TextField source="maxBuildPoints" label="Максимум за билд" />
                <TextField source="maxPresPoints" label="Максимум за презентацию" />

                <FunctionField
                    source="submissionStartDate"
                    label="Начало сдачи"
                    render={(record) => renderDate(record.submissionStartDate)}
                />

                <FunctionField
                    source="submissionDeadlineDate"
                    label="Дедлайн"
                    render={(record) => renderDate(record.submissionDeadlineDate)}
                />
            </Datagrid>
        </List>
    );
};

export default EventList;